const API_BASE = (import.meta as any).env?.VITE_API_BASE_URL || "/api";

export type Shop = {
  id: number;
  name: string;
  type?: string;
  country?: string;
  city?: string;
  logoUrl?: string;
  website?: string;
  address?: string;
  addressTamil?: string;
  addressGerman?: string;
  phone?: string;
  whatsapp?: string;
  email?: string;
  coverUrl?: string;
  verified?: boolean;
  lat?: number;
  lng?: number;
  // Additional properties used in frontend but not yet in backend
  rating?: number;
  reviewCount?: number;
  establishedYear?: number;
  specialties?: string[];
  specialtiesTamil?: string[];
  specialtiesGerman?: string[];
  description?: string;
  descriptionTamil?: string;
  descriptionGerman?: string;
  nameTamil?: string;
  nameGerman?: string;
  imageUrl?: string;
  category?: string;
  categoryTamil?: string;
  categoryGerman?: string;
  isVerified?: boolean;
  cityTamil?: string;
  cityGerman?: string;
  openingHours?: string;
  openingHoursTamil?: string;
  openingHoursGerman?: string;
  owner?: string;
  ownerTamil?: string;
  ownerGerman?: string;
  languages?: string[];
};

export type Page<T> = { content: T[]; totalElements: number };

export async function fetchAllShops(): Promise<Shop[]> {
  const res = await fetch(`${API_BASE}/shops`);
  if (!res.ok) throw new Error("Failed to fetch shops");
  return res.json();
}

export async function pageShops(
  params: {
    page?: number;
    size?: number;
    sort?: string;
    q?: string;
    country?: string;
    city?: string;
  } = {}
): Promise<Page<Shop>> {
  const p = new URLSearchParams();
  if (params.page != null) p.set("page", String(params.page));
  if (params.size != null) p.set("size", String(params.size));
  p.set("sort", params.sort || "createdAt,desc");
  if (params.q) p.set("q", params.q);
  if (params.country) p.set("country", params.country);
  if (params.city) p.set("city", params.city);
  const res = await fetch(`${API_BASE}/shops/page?${p.toString()}`);
  if (!res.ok) throw new Error("shops page failed");
  return res.json();
}

export async function getShop(id: number): Promise<Shop | null> {
  const res = await fetch(`${API_BASE}/shops/${id}`);
  if (!res.ok) return null;
  return res.json();
}

export async function createShop(payload: Partial<Shop>): Promise<Shop> {
  const res = await fetch(`${API_BASE}/shops`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw await parseProblem(res);
  return res.json();
}

export async function updateShop(
  id: number,
  payload: Partial<Shop>
): Promise<Shop> {
  const res = await fetch(`${API_BASE}/shops/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw await parseProblem(res);
  return res.json();
}

export async function deleteShop(id: number): Promise<void> {
  const res = await fetch(`${API_BASE}/shops/${id}`, { method: "DELETE" });
  if (!res.ok) throw await parseProblem(res);
}

async function parseProblem(res: Response): Promise<Error> {
  try {
    const d: any = await res.json();
    return new Error(d?.detail || d?.title || `HTTP ${res.status}`);
  } catch {
    return new Error(`HTTP ${res.status}`);
  }
}
